import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MediaSoupViewer from './MediaSoupViewer';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<MediaSoupViewer />);
